import { render, staticRenderFns } from "./emergencySupplies.vue?vue&type=template&id=27bb76c0&scoped=true&"
import script from "./emergencySupplies.vue?vue&type=script&lang=js&"
export * from "./emergencySupplies.vue?vue&type=script&lang=js&"
import style0 from "./emergencySupplies.vue?vue&type=style&index=0&id=27bb76c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb76c0",
  null
  
)

export default component.exports